import React from "react";

export default function Select({
  value,
  name,
  selectRef,
  options,
  onChange,
  label = null,
  error = null,
  style: wrapperStyle
}) {

  let style = "";

  const hasError = error && error.error === true;

  if (hasError) {
    style = "gc__input_field_error";
  }

  const labelMarkup = ( label ) ? <label className={"gc__input_label"}>{label}</label> : null;

  const errorMarkup = hasError && <p className={"gc__input_field_error_message"}>{ error.message }</p>;

  const opts = options.map((option, index) => {
    return (
      <option
        value={option}
        key={name + "-" + index}
      >
        {option.replace('-', ' ')}
      </option>
    );
  });
  
  return (
    <>
      <div className={"gc__input_container"} style={wrapperStyle}>
        {labelMarkup}
        <select
          ref={selectRef}
          className={`gc__input_field ${style}`}
          name={name}
          value={value}
          onChange={e => onChange(e)}
          // readOnly
        >
        {opts}
        </select>
      </div>
      {errorMarkup}
    </>
  );
};
